import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType } from 'redux-observable';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import UserAuthenticationRequested from '../events/UserAuthenticationRequested';
import { default as CognitoUserAuthenticator, UserSessionDetails } from './CognitoUserAuthenticator';
import UserAuthenticationSucceed from '../events/UserAuthenticationSucceed';
import UserAuthenticationFailed from '../events/UserAuthenticationFailed';

export default (event$: Observable<Event>): Observable<Event> =>
    event$.pipe(
        ofType(UserAuthenticationRequested.type),
        mergeMap((event: UserAuthenticationRequested) => {
            return CognitoUserAuthenticator.authenticateUser(event.login, event.password).pipe(
                map((sessionDetails: UserSessionDetails) => {
                    return new UserAuthenticationSucceed(sessionDetails);
                }),
                catchError((message: string) => {
                    return of(new UserAuthenticationFailed(message));
                })
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/user/epic/authenticateUser.ts